import { createAsyncThunk } from '@reduxjs/toolkit';

import { backendCall, createApiCall } from '@reducers/utils';
import { sendLog } from '@reducers/dataDogs';
import { LOGGER_TITLES } from '@reducers/dataDogs/constants';
import { onClosedProductionOperation, onFailedToCloseProductionOperation } from '@reducers/v2/planboard/planboard.slice';
import { CloseProductionOperationPayload } from '@reducers/v2/planboard/types';
import { RootState, AppDispatch } from '@store/types';

export const closeProductionOperation = createAsyncThunk<
  void,
  CloseProductionOperationPayload,
  { state: RootState; dispatch: AppDispatch }
>('planboard/closeProductionOperation', async ({ productionOperationId, productionOperationNumber, machineId }, { dispatch }) => {
  // Optimistic update - remove from planboard immediately
  dispatch(onClosedProductionOperation({ productionOperationId }));

  try {
    await dispatch(
      backendCall(
        createApiCall((api) => api.productionInformation.closeProductionOperation, {
          params: { productionOperationId },
        })
      )
    );
    // Success - SignalR will confirm the operation
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    const errorStatus = (error as { status?: number })?.status;

    // Log to Datadog
    dispatch(
      sendLog({
        title: LOGGER_TITLES.CLOSE_PRODUCTION_OPERATION_FAILED,
        data: {
          error: errorMessage,
          productionOperationId,
          productionOperationNumber,
          machineId,
          status: errorStatus,
        },
        status: 'error',
      })
    );

    // Dispatch failure action for state tracking (Board component will show Alert and refetch)
    dispatch(
      onFailedToCloseProductionOperation({
        productionOperationId,
        errorMessage,
      })
    );
  }
});
